import React from 'react'

const Grid = ({
                  posts,
                  onSelect,
              }) => {
    const renderGrid = () => posts.map(post => {
        const {
            name,
            image,
            image_bw,
            position,
            id,
            city,
        } = post
        const style = { backgroundImage: `url(${image})` }
        const styleBw = { backgroundImage: `url(${image_bw})` }
        return (
          <div
            key={id}
            onClick={() => onSelect(post)}
            className="consultants__grid-item"
          >
              <div className="consultants__grid-image" style={style}>
                  <div className="consultants__grid-image-bw" style={styleBw}/>
                  <div className="consultants__grid-image-more">Läs mer</div>
              </div>
              <h4 className="consultants__grid-name">{name}</h4>
              <div className="consultants__grid-position">{position}</div>
          </div>
        )
    })
    
    return (
      <div className="consultants__grid">
          {posts.length
           ? renderGrid()
           : <p className="consultants__grid-message">Ingen hittades</p>}
      </div>
    )
}

export default Grid
